// extracted by mini-css-extract-plugin
module.exports = {"removeAllFiltersBtn":"ActiveFilterButtons_removeAllFiltersBtn__3F4rG","searchPhrasesButton":"ActiveFilterButtons_searchPhrasesButton__wIkrS"};